// extracted by mini-css-extract-plugin
export default {"pluginForm":"pluginForm---zpV19"};